module.exports = __webpack_public_path__ + "static/media/Xiaomi Mi Mix Alpha Side.c8f4bcb6.png";